import axios from "axios";
import { signOut } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { BiPowerOff } from "react-icons/bi";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import { firebaseAuth } from "./Firebase";

const DispalayUserDetails = () => {
  const { user, getUserNameDetails, userName } = useStateContext();

  useEffect(() => {
    getUserNameDetails(user.email);
  }, [user]);
  function trauncate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + '...' : string
  }
  return (
    <Component>
      <div className="border-image-div">
        <AiOutlineUser className="user" />
      </div>
      <p style={{ fontSize: 14 }}>Signed in as :-</p>
      <UserInfo>
        {/*  */}
        <p> {trauncate(user.email, 17)}</p>
        <p> {userName}</p>
      </UserInfo>
      <button onClick={() => signOut(firebaseAuth)}>
        Logout <BiPowerOff className="power" />
      </button>
    </Component>
  );
};

export default DispalayUserDetails;

const Component = styled.div`
  width: 30vw;
  height: auto;
  border: 1px solid #fff;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  border-top-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding: 10px;
  padding-bottom: 17px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #f7d8ee;
  backdrop-filter: blur(20px);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  .border-image-div {
    height: 70px;
    width: 70px;
    background-color: #d485bf;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .user {
    font-size: 40px;
  }

  button {
    cursor: pointer;
    margin-top: 20px;
    padding: 14px 4px;
    width: 80%;
    outline: none;
    border-radius: 4px;
    background-color: transparent;
    border: 1px solid #de80c2;
    display: flex;
    justify-content: center;
    align-items: center;
    .power {
      padding-left: 4px;
      font-size: 17px;
      color: #ed4b4b;
      cursor: pointer;
    }
  }
  @media (max-width: 481px) {
    width: 70vw;
  }
`;

const UserInfo = styled.div`
  line-height: 10px;
`;
